<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-code">
            <div class="code-QR text-center">
                <div class="common-text mb-4">
                    Заселение гостей в номер {{name}}
                </div>
                <div v-if="link">
                    <qrcode-vue :value="link" size="180" level="H"></qrcode-vue>
                </div>
                <div class="code-link" v-if="link">
                    <div class="common-text mt-5">
                        Ссылка для ручного ввода:
                    </div>
                    <div class="w-100 text-left">{{ link }}</div>
                </div>
            </div>
            <v-flex class="d-flex w-100 justify-end mt-6">
                <v-btn class="btn-grey main-text" @click="close">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="printCode">
                    Печать
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
    name: "ModalQRCode",
    components: {QrcodeVue},
    props: {
        value: {
            type: Boolean,
        },
        qrlink: {
            type: String,
            default: "",
        },
        name: {
            type: String,
        },
    },
    data() {
        return {
            dialog: false,
            link: null,
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
        qrlink(val) {
            if (val) {
                this.link = `${process.env.VUE_APP_LK_API_URL}/?master_key=${val}`;
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.$emit("input", false);
        },
        printCode() {
            this.$root.$emit('printPage');
            this.close();
        },
    },
}
</script>

<style lang="scss" scoped>
.modal-code.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 105px;
}
</style>